module.exports = __webpack_public_path__ + "static/media/DentalLLMPerCom.9c42b6f9.png";